// extracted by mini-css-extract-plugin
export default {"form":"TicketForm_form__5CJI3","button":"TicketForm_button__rusj-","formGroup":"TicketForm_formGroup__hQz8H","editor":"TicketForm_editor__hq6oQ"};